import React from 'react';
import { BodyText, BoldBodyText } from '../../../ui-toolkit';
import { eRowPresentationStyle } from '../../../types/clientPortal/Fees/eRowPresentationStyle';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export const FeeTextComponent: FCWithChildren<{ style: eRowPresentationStyle }> = ({ style, children }) =>
  style === eRowPresentationStyle.header ? <BoldBodyText>{children}</BoldBodyText> : <BodyText>{children}</BodyText>;
